export const toUrlQuery = (
  params: Record<string, Parameters<typeof encodeURIComponent>[0]>,
  prefix: '&' | '?' | '/' | '' = '?',
): string => {
  const query = Object.keys(params)
    .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
    .join('&');
  return query ? `${prefix}${query}` : '';
};
